<div class="info-container">
    <div class="inner scrollbars">
        <div class="info-content" [innerHTML]="info.content" *ngIf="info"></div>
        <div class="info-sponsors" *ngIf="info.sponsors">
            <h2 [innerHTML]="info.sponsors_header"></h2>
            <ul class="sponsors-list">
                <li class="sponsor-item" *ngFor="let sponsor of info.sponsors">
                    <img
                        [src]="sponsor.logo"
                        [style.maxWidth]="sponsor.width ? (sponsor.width + 'px') : ''"
                    >
                </li>
            </ul>
        </div>
    </div>
</div>
